module.exports = __webpack_public_path__ + "static/img/Group 540@2x.e52d86b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group 540@2x.png
// module id = 47
// module chunks = 1